module.exports = __webpack_public_path__ + "img/leave.b7673696.svg";